'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LEFT = 'left';
var RIGHT = 'right';

/**
 * Returns the styles that generate a fading effect on the edges of the timeline
 *
 * @param  {object} styles The styles (user-definded/default).Mainly Information about the background, foreground, etc.
 * @param  {string} position The position of the fader. Can only be left or right
 * @param  {string} gradientDirection The direction in which we want to generate fade effect
 * @return {object} The styleing Information for the left or right fader
 */
var faderStyle = {
  base: {
    top: '50%',
    position: 'absolute',
    bottom: 'auto',
    transform: 'translateY(-50%)',
    height: '100%',
    width: 20,
    overflow: 'hidden'
  },
  specific: function specific(styles, position, gradientDirection) {
    var _ref;

    return _ref = {}, _defineProperty(_ref, position, 39), _defineProperty(_ref, 'backgroundImage', 'linear-gradient(to ' + gradientDirection + ', ' + styles.background + ', ' + (0, _color2.default)(styles.background).alpha(0).rgb() + ')'), _ref;
  }
};

/**
 * The markup Information for an element that produces the fade effect at the end of the timeline
 *
 * @param  {object} props The props from parent mainly styles
 * @return {StatelessFunctionalReactComponent} Markup Information for the fader
 */
var Faders = function Faders(props) {
  return _react2.default.createElement(
    'ul',
    { style: { listStyle: 'none' } },
    _react2.default.createElement('li', { style: [faderStyle.base, faderStyle.specific(props.styles, LEFT, RIGHT)] }),
    _react2.default.createElement('li', { style: [faderStyle.base, faderStyle.specific(props.styles, RIGHT, LEFT)] })
  );
};

/**
 * The styles that parent will provide
 * @type {Object}
 */
Faders.propTypes = {
  styles: _propTypes2.default.shape({
    foreground: _propTypes2.default.string.isRequired,
    background: _propTypes2.default.string.isRequired,
    outline: _propTypes2.default.string.isRequired
  })
};

exports.default = (0, _radium2.default)(Faders);


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/timeline/react-horizontal-timeline/Components/Faders.js
// module id = 1148
// module chunks = 0